module.exports = __webpack_public_path__ + "img/accessory_shoe_01.b4b84995.svg";